<template>
  <div class="mainPages">
    <el-row>
      <div class="pageNav">
        <router-link
          :to="type===2 || type===4?'/admin/saleOrders':type===3?'/admin/recycleOrders':'/admin/clientManager'">
          <el-button class="returnPrevious" type="primary" icon="el-icon-d-arrow-left">
            {{type===2 || type===4?'返回销货开单':type===3?'返回回收开单':'返回客户管理'}}
          </el-button>
        </router-link>
        <div class="verticalLine"></div>
        <el-link class="descTitle" type="primary" :underline="false">{{(type===1 ||
          type===4)?'编辑客户':type===3?'新增交回者':'新增客户'}}
        </el-link>
      </div>
      <div class="horizontalLine"></div>
    </el-row>

    <div class="mainForm">
      <el-form :model="client" :rules="rules" ref="client" label-width="120px" class="demo-client store-info-form">
        <el-form-item class="labelTitle" label="店铺名称" prop="clientName" v-if="type === 0 || type===2 || type===3">
          <el-autocomplete
            class="inputLine"
            style="width: 371px;"
            v-model="client.clientName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入店铺名称"
            @select="handleSelect">
            <template slot-scope="{ item }">
              <div class="name">{{ item.clientName }} ( {{ item.clientPerson }} : {{ item.clientPhone }} )</div>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item class="labelTitle" label="店铺名称" prop="clientName" v-if="this.type === 1">
          <el-input class="inputLine" v-model="client.clientName" placeholder="请输入店铺名称" maxlength="50"
                    clearable></el-input>
        </el-form-item>

        <el-form-item class="labelTitle" label="客户名称" prop="clientPerson">
          <!--
          <el-input class="inputLine" v-model="client.clientPerson" placeholder="请输入客户名称" maxlength="20"
                    @blur="checkClientPersonIsRepeat" clearable></el-input>
          -->
          <el-input class="inputLine" v-model="client.clientPerson" placeholder="请输入客户名称" maxlength="20" clearable></el-input>
        </el-form-item>

        <el-form-item class="labelTitle" label="手机号" prop="clientPhone">
          <el-input class="inputLine" v-model="client.clientPhone" placeholder="请输入手机号" @blur="clientPhoneCheck"
                    clearable></el-input>
        </el-form-item>
        <el-row>
          <div class="sfzIconBox">
            <div class="clickBox" @click="getIdentityInfo">
              <div class="sfzTitle">实名认证<span class="mastIcon" v-show="type==4 || client.idCertified">*</span></div>
              <svg t="1644994176674" class="sfzIcon" viewBox="0 0 1820 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg"
                   p-id="1238">
                <path
                  d="M1403.012741 900.475259v-14.838518h63.137185v-62.786371h14.91437v77.624889h-78.051555z m63.146666-761.799111h-63.137185v-14.838518h78.051556v77.568h-14.914371v-62.729482z m-55.646814 46.933333c8.078222 7.973926 12.61037 18.868148 12.591407 30.217482v582.949926c-0.009481 23.580444-19.237926 42.695111-42.960593 42.714074H431.094519c-23.722667-0.028444-42.932148-19.143111-42.960593-42.714074V215.826963c0.028444-23.561481 19.247407-42.657185 42.960593-42.68563h949.067851c11.425185-0.009481 22.20563 4.41837 30.350223 12.468148z m-30.33126 6.418963H431.094519v0.018963c-13.217185 0.018963-23.931259 10.657185-23.940741 23.798519v582.940444c0 13.112889 10.742519 23.817481 23.940741 23.817482h949.048888c13.198222 0 23.959704-10.68563 23.959704-23.817482V215.826963c0-6.352593-2.49363-12.344889-7.016296-16.839111a24.267852 24.267852 0 0 0-16.905482-6.959408zM1029.499259 683.121778c0.777481-37.290667 7.68-100.920889 45.018074-133.300148l51.399111 0.464592 48.137482 78.933334 9.073778-59.022223-6.561185-10.704592 0.493037-10.998519a213.333333 213.333333 0 0 1 28.605629 0.037926l0.530963 10.998519-6.542222 10.695111 9.111704 59.496296 37.385481-79.815111 56.860445-1.924741c29.392593 27.619556 48.232296 92.681481 43.614814 135.130074H1029.499259z m239.094519-218.965334c-3.915852 13.909333-8.495407 26.804148-15.056593 37.603556-7.49037 12.47763-17.408 22.072889-31.412148 27.240296-6.257778 2.247111-22.253037 3.328-37.641481 3.062519-14.838519-0.18963-29.743407-1.659259-35.678815-4.389926-12.743111-5.802667-21.703111-15.606519-28.453926-27.799704-5.82163-10.410667-9.946074-22.546963-13.577482-35.365926-5.95437-3.100444-10.420148-8.372148-13.44474-15.568592-3.280593-7.822222-4.788148-18.10963-4.598519-30.293334l0.056889-4.16237 3.479704-2.304c0.872296-0.587852 1.763556-1.156741 2.664296-1.659259-3.915852-47.900444-2.436741-65.60237 15.464296-85.845334 34.901333-28.387556 114.887111-27.382519 150.224593-1.649777 24.073481 22.603852 25.751704 47.928889 18.356148 87.011555 1.156741 0.663704 2.294519 1.365333 3.460741 2.133333l3.479703 2.322963 0.047408 4.143408c0.199111 11.937185-1.242074 22.053926-4.399408 29.866667-2.929778 7.120593-7.205926 12.439704-12.970666 15.653925z m-0.436148-41.509925c-1.327407-0.474074-2.721185-0.682667-4.124445-0.625778l-7.092148 0.455111-1.308444-6.940445a89.596207 89.596207 0 0 0-7.367112-22.490074c-22.632296 4.408889-56.272593 8.25837-82.858666-6.627555-10.249481-5.726815-25.220741 6.011259-37.508741 4.797629-3.887407 7.68-6.674963 15.862519-8.286815 24.32l-1.374815 7.196445-7.262814-0.692148c-1.431704-0.104296-2.872889 0.06637-4.238223 0.512-0.663704 0.218074-1.327407 0.483556-1.962666 0.777481 0.170667 7.973926 1.289481 14.563556 3.384889 19.522371 1.829926 4.342519 4.352 7.158519 7.670518 8.201481l4.257185 1.327407 1.175704 4.247704c3.574519 13.103407 7.537778 25.514667 13.169778 35.593482 5.205333 9.339259 11.880296 16.801185 21.067852 21.001481 3.877926 1.773037 16.241778 2.759111 29.155555 2.948741 13.729185 0.18963 27.410963-0.512 31.93363-2.180741 10.17363-3.726222 17.512296-10.960593 23.201185-20.404148 6.087111-10.154667 10.439111-23.04 14.260148-37.176889l1.109334-4.067555 4.029629-1.40326c3.195259-1.118815 5.688889-4.02963 7.490371-8.410074 1.98163-4.873481 3.062519-11.377778 3.271111-19.181037-0.57837-0.284444-1.175704-0.512-1.792-0.701629z m-678.418963 47.815111H808.865185v37.404444H589.738667v-37.404444z m0-93.098667H808.865185v37.404444H589.738667V377.362963z m0-93.098667H808.865185v37.394963H589.738667v-37.394963zM490.202074 470.46163h72.760889v37.404444h-72.760889v-37.404444z m0-93.098667h72.760889v37.404444h-72.760889V377.362963z m0-93.098667h72.760889v37.394963h-72.760889v-37.394963zM683.406222 751.407407H490.202074v-37.413926h193.204148v37.413926z m352.142222 0H706.000593v-37.413926h329.547851v37.413926zM352.360296 201.40563h-14.933333v-77.568h78.070518v14.838518h-63.146666v62.729482z m0 684.231111h63.146667v14.838518h-78.070519v-77.624889h14.933334v62.786371z m0 0"
                  p-id="1239" fill="#409EFF"></path>
              </svg>
              <div class="clickMessage">
                <div>点击这里使用身份证阅读器</div>
                <div>自动填入一键录入客户信息</div>
              </div>
            </div>
          </div>
        </el-row>

        <el-form-item class="labelTitle" label="真实姓名" prop="realName" >
          <span slot="label" v-if="mastInput">真实姓名<span class="mastIcon">*</span></span>
          <span slot="label" v-else>真实姓名</span>
          <el-input class="inputLine" v-model="client.realName" placeholder="请输入真实姓名" maxlength="50"
                    @input="realNameInput"></el-input>
        </el-form-item>
        <el-form-item class="labelTitle" label="身份证号" prop="identityCode" >
          <span slot="label" v-if="mastInput">身份证号<span class="mastIcon">*</span></span>
          <span slot="label" v-else>身份证号</span>
          <el-input class="inputLine" v-model="client.identityCode" placeholder="请输入身份证号" maxlength="18"
                    @blur="checkidentityCode"
                    @input="idInput"></el-input>
        </el-form-item>
        <el-form-item class="labelTitle" label="详细地址" prop="addressDesc" >
          <span slot="label" v-if="mastInput">详细地址<span class="mastIcon">*</span></span>
          <span slot="label" v-else>详细地址</span>
          <el-input type="textarea" class="inputLineArea" v-model="client.addressDesc" placeholder="请输入详细地址"
                    maxlength="100"
                    clearable show-word-limit></el-input>
        </el-form-item>

        <div class="cropBox">
          <div class="cropTitle">种植作物<span class="mastIcon" v-show="type==4 || client.idCertified">*</span></div>
          <el-tabs type="border-card" class="cropCat">
            <el-tab-pane v-for="item in cropTree" :label="item.categoryName" :key="item.categoryId">
              <el-checkbox-group v-model="checkCrops" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="itemChildren in item.childrenNode" :key="itemChildren.categoryId"
                             :label="itemChildren.categoryId" @change="cropCheck(itemChildren)">
                  {{itemChildren.categoryName}}
                </el-checkbox>
              </el-checkbox-group>
            </el-tab-pane>
          </el-tabs>
          <div class="cropCheckBox">
            <el-tag class="cropTag"
                    :key="tag.categoryId"
                    v-for="tag in checkCropsDetail"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
              <template>
                <el-row class="cropCheckRow">
                  <div class="inputBox">
                    <div class="inputTitle">{{tag.categoryName}}：</div>
                    <el-input-number class="cropInput" v-model="tag.num" :step="1"
                                     @change="categoryNumberChange(tag)" :min="1" :max="10000"
                                     @blur="categoryReCheck(tag)"
                                     label="请输入亩数"></el-input-number>
                    <span class="numUnit">亩</span>
                  </div>
                </el-row>

              </template>
            </el-tag>
          </div>

        </div>
        <el-form-item class="labelTitle" label="状态" prop="status" v-if="this.type === 1">
          <el-radio-group class="checkGroup" v-model="client.status" @change="radioChange">
            <el-radio-button class="statusOpen" :label="SUPPLIER_STATUS.OPEN.key">启用</el-radio-button>
            <el-radio-button class="statusStop" :label="SUPPLIER_STATUS.STOP.key">停用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div v-if="showStopInfo" class="showStopInfo">
          <div class="stopInfo">提示：客户已停用，停用的客户将不会出现在开单时的“选择客户”页面。</div>
          <div class="stopInfo">可使用“客户管理”页面显示出已停用的客户。</div>
        </div>
        <el-form-item class="labelTitle" label="备注" prop="remark">
          <el-input id="stockDescription" class="inputLineArea" :rows="2"
                    type="textarea" maxlength="500" show-word-limit v-model="client.remark" clearable
                    placeholder="请输入备注信息，最多500个字符"></el-input>
        </el-form-item>

        <el-form-item class="storeInfoSub">
          <el-button class="storeInfoBtn" type="danger" @click="save('client')">保存</el-button>
          <el-button class="resetBtn" @click="resetForm('client')" v-if="this.type === 0">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SupplierManager',
    data () {
      let validate_realName = (rule, value, callback) => {
        function getLength (str) {
          //如果为中文，替换为ccc，1个中文字符计算长度=1
          return str.replace(/[^x00-xff]/g, 'c').length
        }

        if (!value && this.mastInput) {
          callback(new Error('请填写您的真实姓名'))
        } else if (value && getLength(value) > 50) {
          callback(new Error('真实姓名最多不能超过50个字符'))
        } else {
          callback()
        }
      }
      let validate_clientPerson = (rule, value, callback) => {
        function getLength (str) {
          //如果为中文，替换为ccc，1个中文字符计算长度=1
          return str.replace(/[^x00-xff]/g, 'c').length
        }

        if (!value) {
          callback(new Error('请填写联系人'))
        } else if (getLength(value) > 20) {
          callback(new Error('联系人最多不能超过20个字符'))
        } else {
          callback()
        }
      }
      let validate_clientName = (rule, value, callback) => {
        function getLength (str) {
          //如果为中文，替换为ccc，1个中文字符计算长度=1
          return str.replace(/[^x00-xff]/g, 'c').length
        }

        if (value && getLength(value) > 50) {
          callback(new Error(this.type === 3 ? '交回者名称最多不能超过50个字符' : '客户名称最多不能超过50个字符'))
        } else {
          callback()
        }
      }
      let validate_identityCode = (rule, value, callback) => {

        if (!value && this.mastInput) {
          callback(new Error('请填写身份证号'))
        } else if (value.indexOf('*') === -1 && !Pattern.validate('idCode', value) && Tool.isNotEmpty(this.client.identityCode)) {
          callback(new Error('请填写您本人的正确身份证号'))
        } else {
          callback()
        }
      }
      let validate_clientPhone = (rule, value, callback) => {
        if (value && !Pattern.validate('mobile', value)) {
          callback(new Error('请输入正确的手机号'))
        } else if (!value) {
          callback(new Error('请填写手机号'))
        } else {
          callback()
        }
      }
      let validate_addressDesc = (rule, value, callback) => {
        function getLength (str) {
          //如果为中文，替换为ccc，1个中文字符计算长度=1
          return str.replace(/[^x00-xff]/g, 'c').length
        }

        if (value && getLength(value) > 500) {
          callback(new Error('备注最多不能超过500个字符'))
        } else if (!value && this.mastInput) {
          callback(new Error('请填写详细地址'))
        } else {
          callback()
        }
      }
      let validate_remark = (rule, value, callback) => {
        function getLength (str) {
          //如果为中文，替换为ccc，1个中文字符计算长度=1
          return str.replace(/[^x00-xff]/g, 'c').length
        }

        if (value && getLength(value) > 500) {
          callback(new Error('备注最多不能超过500个字符'))
        } else {
          callback()
        }
      }
      return {
        message: '客户编辑',
        type: 0,
        searchInput: '',
        checkedStop: false,//默认不显示停用客户
        clientName: '',
        client: {
          clientName: '', //店铺名称
          clientPerson: '', //客户名称
          clientPhone: '', //手机号
          status: 0, //状态
          remark: '', //备注
          realName: '',//真实姓名
          addressDesc: '',//详细地址
          identityCode: '',//身份证号
          idCertified: false,
          cropList: [],
        },
        mastInput: false,
        secretPsd: '',//加密证件号
        decryptPsd: '',//解密证件号
        decryptCode: '',//解密后*加密证件号
        cropTree: [],
        cropNoTree: [],
        checkCrops: [],//选中的id
        checkCropsDetail: [],//选中的作物对象
        checkArea: [],
        SUPPLIER_STATUS: SUPPLIER_STATUS,
        //禁用提示
        showStopInfo: false,
        rules: {
          clientName: [
            {
              validator: validate_clientName,
              trigger: 'blur'
            }
          ],
          clientPerson: [
            {
              required: true,
              validator: validate_clientPerson,
              trigger: 'blur'
            }
          ],
          clientPhone: [
            {
              required: true,
              validator: validate_clientPhone,
              trigger: 'blur'
            }
          ],
          realName: [
            {
              validator: validate_realName,
              trigger: 'blur'
            }
          ],
          identityCode: [
            {

              validator: validate_identityCode,
              trigger: 'blur'
            }
          ],
          addressDesc: [
            {

              validator: validate_addressDesc,
              trigger: 'blur'
            }
          ],
          remark: [
            {
              validator: validate_remark,
              trigger: 'blur'
            }
          ],
        },

        //联想下拉列表输入框
        restaurants: [],
        state: '',
        timeout: null,
        openSocket:true
      }
    },
    mounted () {
      let clientInfo = {}
      let flag = Tool.getAuthorityRouter(this.$route.path.substr(1))
      if (!flag) {
        this.$emit('noAuth')
      }
      this.openSocket=true
      //编辑：type=1 新增：type=0
      if (this.$route.params.type === 1 || this.$route.params.type === 4) {
        this.client = this.$route.params.item || {}
        this.type = this.$route.params.type
        //查看详情
        this.queryCustomDetail(this.client.clientId)
        if (this.client.status === 1) {
          this.showStopInfo = true
        }
        if (this.type === 4 || this.client.idCertified) {
          this.mastInput = true
        }
      } else if (this.$route.params.type === 0 || this.$route.params.type === 2 || this.$route.params.type === 3) {
        this.client.status = 0
        this.type = this.$route.params.type
        clientInfo.client = this.client
        clientInfo.type = this.type
        SessionStorage.set(CLIENT_INFO, clientInfo)
      } else {
        clientInfo = SessionStorage.get(CLIENT_INFO)
        this.client = clientInfo.client
        this.type = clientInfo.type
        this.mastInput = clientInfo.mastInput
        this.checkCropsDetail = []
        this.checkCrops = []
        let crops = this.client.clientCropAreaList
        if(crops){
          for (let i = 0; i < crops.length; i++) {
            crops[i].num = 1
            this.checkCrops.push(crops[i].categoryId)
            this.checkCropsDetail.push(crops[i])
          }
        }

      }
      this.getCropTree()
      this.getCropNoTree()
      //this.type = clientInfo.type
      this.navChange()
      this.changeCropWidth()
      this.socketIOIdScan()
    },
    methods: {
      clientPhoneCheck () {
        if (Pattern.validate('mobile', this.client.clientPhone)) {
          this.clientPhoneAgain();
          this.checkClientPhoneIsRepeat();
        }
      },
      handleClose (tag) {
        this.checkCropsDetail.splice(this.checkCropsDetail.indexOf(tag), 1)
        this.checkCrops.splice(this.checkCrops.indexOf(tag.categoryId), 1)
      },
      realNameInput () {
        let _this = this
        /*if (_this.client.realName.length < 1 && _this.mastInput) {
          setTimeout(function () {
            let errorTag = document.getElementsByClassName('el-form-item__error').parent
            console.log(errorTag)
            // errorTag.innerHTML='请填写您的真实姓名'
          },10)
        }*/
      },
      idInput () {
        let _this = this
      },
      clientPhoneAgain () {
        this.$axios.post(process.env.VUE_APP_SERVER + '/psi/client/selectByclientPhone?clientPhone=' + this.client.clientPhone)
          .then((response) => {
            Loadings.hide()
            if (response.status === 200) {
              if (response.data.code === 200 && Tool.isNotEmpty(response.data.data)) {
                //console.log('获取的客户信息：response：', response)
                this.client.realName = response.data.data.realName
                this.client.addressDesc = response.data.data.addressDesc

                if (!Tool.isEmpty(response.data.data.identityCode)) {
                  this.secretPsd = response.data.data.identityCode
                  this.decryptPsd = BaseDecrypt.decode(this.secretPsd)
                  //console.log('当前身份证：', this.secretPsd, '解密：', this.decryptPsd)
                  let subID = this.decryptPsd.substring(1, 17)
                  let subSecret = []
                  for (let i = 0; i < subID.length; i++) {
                    subSecret.push('*')
                  }
                  this.decryptCode = this.decryptPsd.substr(0, 1) + subSecret.toString().replace(/,/g, '') + this.decryptPsd.substr(this.decryptPsd.length - 1)
                  this.client.identityCode = this.decryptCode
                 //console.log('identityCode: ', this.identityCode)
                }
                this.checkCropsDetail = []
                this.checkCrops = []
                let crops = response.data.data.clientCropAreaList
                for (let i = 0; i < crops.length; i++) {
                  crops[i].num = 1
                  this.checkCrops.push(crops[i].categoryId)
                  this.checkCropsDetail.push(crops[i])
                }
              }
            }
          })
      },
      checkidentityCode () {
        if (Tool.isNotEmpty(this.client.identityCode) && (this.client.identityCode.indexOf('*') === -1 || Pattern.validate('idCode', this.client.identityCode))) {
          this.checkidentityCodeIsRepeat()
        }
      },
      //检查身份证号是否重复
      checkidentityCodeIsRepeat () {
        Loadings.show()
        let idCode=BaseDecrypt.encode(this.client.identityCode)
        if(Tool.isNotEmpty(this.client.dataSources)){
          idCode=this.decryptPsd
        }
        this.$axios.request({
          url: process.env.VUE_APP_SERVER + '/psi/client/selectByIdentityCode?identityCode=' + idCode,
          method: 'POST'
        })
          .then((res) => {
            Loadings.hide()
            if (!Tool.isEmpty(res.data.data)) {
              //console.log('data: ', res.data.data)
              this.client.realName = res.data.data.realName
              this.client.addressDesc = res.data.data.addressDesc

              if (!Tool.isEmpty(res.data.data.identityCode)) {
                this.secretPsd = res.data.data.identityCode
                if(Tool.isNotEmpty(this.client.dataSources)){
                  this.decryptPsd = res.data.data.identityCode
                }else{
                  this.decryptPsd = BaseDecrypt.decode(this.secretPsd)
                }

                let subID = this.decryptPsd.substring(1, this.decryptPsd.length-1)
                let subSecret = []
                for (let i = 0; i < subID.length; i++) {
                  subSecret.push('*')
                }
                this.decryptCode = this.decryptPsd.substr(0, 1) + subSecret.toString().replace(/,/g, '') + this.decryptPsd.substr(this.decryptPsd.length - 1)
                this.client.identityCode = this.decryptCode
              }
              this.checkCropsDetail = []
              this.checkCrops = []
              let crops = res.data.data.clientCropAreaList
              for (let i = 0; i < crops.length; i++) {
                crops[i].num = 1
                this.checkCrops.push(crops[i].categoryId)
                this.checkCropsDetail.push(crops[i])
              }
            }
          })
        this.changeCropWidth()
      },
      getCropTree () {
        this.$axios.request({
          url: process.env.VUE_APP_SERVER + '/psi/cropCategory/queryCropCategoryTree',
          method: 'GET'
        })
          .then((res) => {
            if (res.status === 200) {
              if (res.data.code != 200) {
                this.$message({
                  type: 'warning',
                  message: res.data.msg,
                  duration: 2000,
                  offset: 110
                })
              } else {
                let crops = res.data.data
                this.cropTree = crops
              }
            }
          })
      },
      getCropNoTree () {
        this.$axios.request({
          url: process.env.VUE_APP_SERVER + '/psi/cropCategory/queryAll',
          method: 'GET'
        })
          .then((res) => {
            if (res.status === 200) {
              if (res.data.code != 200) {
                this.$message({
                  type: 'warning',
                  message: res.data.msg,
                  duration: 2000,
                  offset: 110
                })
              } else {
                let crops = res.data.data
                for (let i = 0; i < crops.length; i++) {
                  crops[i].num = 1
                }
                this.cropNoTree = crops
              }
            }
          })
      },
      categoryNumberChange (tag) {
        if (tag.num < 1 || Tool.isEmpty(tag.num)) {
          tag.num = 1
          for (let i = 0; i < this.checkCropsDetail.length; i++) {
            if (this.checkCropsDetail[i].categoryId === tag.categoryId) {
              this.checkCropsDetail.splice(i, 1, tag)
              this.$forceUpdate()
            }
          }
        }
        this.changeCropWidth()
      },
      categoryReCheck (tag) {
        let _this = this
        setTimeout(function () {
          let inputs = document.getElementsByClassName('cropInput')
          for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].childNodes[2].childNodes[1].getAttribute('aria-valuenow') === 'undefined') {
              inputs[i].childNodes[2].childNodes[1].value = 1
            }
          }

          if (tag.num < 1 || Tool.isEmpty(tag.num)) {
            tag.num = 1
            for (let i = 0; i < _this.checkCropsDetail.length; i++) {
              if (_this.checkCropsDetail[i].categoryId === tag.categoryId) {
                _this.checkCropsDetail.splice(i, 1, tag)
                _this.$forceUpdate()
              }
            }
          }
        }, 10)
        this.changeCropWidth()
      },
      handleCheckedCitiesChange (value) {
        let cropCheckBox = document.getElementsByClassName('cropCheckBox')[0]
        this.checkCropsDetail = []
        for (let i = 0; i < value.length; i++) {
          for (let j = 0; j < this.cropNoTree.length; j++) {
            if (value[i] === this.cropNoTree[j].categoryId) {
              this.checkCropsDetail.push(this.cropNoTree[j])
            }
          }
        }
        this.changeCropWidth()
      },
      changeCropWidth () {
        let _this = this
        setTimeout(function () {
          //js执行快于dom渲染，需要延迟获取
          _this.$nextTick(() => {
            let closeTag = document.getElementsByClassName('cropCheckBox')[0].children
            for (let i = 0; i < closeTag.length; i++) {
              //console.log("closeTag-inputTitle: ",closeTag[i].children[0].children[0].children[0].innerHTML)
              if (closeTag[i].children[0].children[0].children[0].innerHTML.length === 4) {
                closeTag[i].children[1].style.right = '-130px'
              } else if (closeTag[i].children[0].children[0].children[0].innerHTML.length === 5) {
                closeTag[i].children[1].style.right = '-135px'
              } else if (closeTag[i].children[0].children[0].children[0].innerHTML.length === 6) {
                closeTag[i].children[1].style.right = '-142px'
              } else if (closeTag[i].children[0].children[0].children[0].innerHTML.length === 7) {
                closeTag[i].children[1].style.right = '-150px'
              } else if (closeTag[i].children[0].children[0].children[0].innerHTML.length > 7) {
                closeTag[i].children[1].style.right = '-155px'
              }

            }
          })
        }, 200)

      },
      cropCheck (value) {
        //console.log('checkValue: ', value)

      },
      querySearchAsync (queryString, cb) {

        if (!this.client.clientName || this.client.clientName == '') {
          clearTimeout(this.timeout)
          cb([])
          return
        }

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$axios.request({
            url: process.env.VUE_APP_SERVER + '/psi/client/selectClientByName?clientName=' + this.client.clientName,
            method: 'GET',
          })
            .then((res) => {
              if (res.status == 200) {
                if (res.data.code == 200) {
                  this.restaurants = res.data.data
                  cb(this.restaurants)
                } else {
                  cb([])
                  this.$message({
                    type: 'warning',
                    message: res.data.msg,
                    duration: 2000,
                    offset: 110
                  })
                }
              } else {
                cb([])
                this.$message({
                  type: 'warning',
                  message: '网络异常',
                  duration: 2000,
                  offset: 110
                })
              }
            })
        }, 1000 * Math.random())
      },
      createStateFilter (queryString) {
        return (state) => {
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      handleSelect (item) {
        this.client.clientName = item.clientName
        this.client.clientPerson = item.clientPerson
        this.client.clientPhone = item.clientPhone
      },
      //查看详情
      queryCustomDetail (clientId) {
        this.$axios.request({
          url: process.env.VUE_APP_SERVER + '/psi/client/detail?clientId=' + clientId,
          method: 'GET',
        })
          .then((res) => {

            if (res.status === 200) {
              if (res.data.code === 200) {
                this.client = res.data.data
                // console.log("当前客户id----------：",this.client)
                // console.log("res.data.data",res.data.data)
                if (Tool.isNotEmpty(this.client.identityCode)) {
                  this.secretPsd = res.data.data.identityCode
                  if(Tool.isNotEmpty(this.client.dataSources)){
                    this.decryptPsd = res.data.data.identityCode
                  }else{
                    this.decryptPsd = BaseDecrypt.decode(res.data.data.identityCode)
                  }
                  // console.log("解码：",this.decryptPsd)
                  let subID = this.decryptPsd.substring(1, this.decryptPsd.length-1)
                  let subSecret = []
                  for (let i = 0; i < subID.length; i++) {
                    subSecret.push('*')
                  }
                  this.decryptCode = this.decryptPsd.substr(0, 1) + subSecret.toString().replace(/,/g, '') + this.decryptPsd.substr(this.decryptPsd.length - 1)
                  this.client.identityCode = this.decryptCode

                }
                if (this.type === 4 || this.client.idCertified) {
                  this.mastInput = true
                }
                this.checkCropsDetail = []
                this.checkCrops = []
                let crops = res.data.data.clientCropAreaList
                for (let i = 0; i < crops.length; i++) {
                  crops[i].num = 1
                  this.checkCrops.push(crops[i].categoryId)
                  this.checkCropsDetail.push(crops[i])
                }

                let clientInfo = {}
                clientInfo.type = this.type
                clientInfo.client = this.client
                clientInfo.mastInput = this.mastInput
                SessionStorage.set(CLIENT_INFO, clientInfo)
                this.$forceUpdate()
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.msg,
                  duration: 2000,
                  offset: 110
                })
              }
            } else {
              this.$message({
                type: 'warning',
                message: '网络异常',
                duration: 2000,
                offset: 110
              })
            }
          })
      },
      //检查是否重复
      checkClientPersonIsRepeat () {
        if (!this.client.clientPerson) {
          return
        }
        if (this.type === 0 || this.type === 2 || this.type === 3) {
          this.$axios.request({
            url: process.env.VUE_APP_SERVER + '/psi/client/repetitionClient?clientPerson=' + this.client.clientPerson,
            method: 'GET'
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.code != 200) {
                  this.$message({
                    type: 'warning',
                    message: res.data.msg,
                    duration: 2000,
                    offset: 110
                  })
                }
              } else {
                this.$message({
                  type: 'warning',
                  message: '网络异常',
                  duration: 2000,
                  offset: 110
                })
              }
            })
        } else if (this.type === 1 || this.type === 4) {
          this.$axios.request({
            url: process.env.VUE_APP_SERVER + '/psi/client/repetitionClient' +
              '?clientPerson=' + this.client.clientPerson +
              '&clientId=' + this.client.clientId,
            method: 'GET'
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.code != 200) {
                  this.$message({
                    type: 'warning',
                    message: res.data.msg,
                    duration: 2000,
                    offset: 110
                  })
                }
              } else {
                this.$message({
                  type: 'warning',
                  message: '网络异常',
                  duration: 2000,
                  offset: 110
                })
              }
            })
        }
      },
      //校验客户手机号是否重复
      checkClientPhoneIsRepeat() {
        if (!this.client.clientPhone) {
          return;
        }
        if (this.type === 0 || this.type === 2 || this.type === 3) {
          this.$axios.request({
            url: process.env.VUE_APP_SERVER + '/psi/client/repetitionClientByClientPhone?clientPhone=' + this.client.clientPhone,
            method: 'GET'
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.code != 200) {
                  this.$message({
                    type: 'warning',
                    message: res.data.msg,
                    duration: 2000,
                    offset: 110
                  })
                }
              } else {
                this.$message({
                  type: 'warning',
                  message: '网络异常',
                  duration: 2000,
                  offset: 110
                })
              }
            })
        } else if (this.type === 1 || this.type === 4) {
          this.$axios.request({
            url: process.env.VUE_APP_SERVER + '/psi/client/repetitionClientByClientPhone' +
              '?clientPhone=' + this.client.clientPhone +
              '&clientId=' + this.client.clientId,
            method: 'GET'
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.code != 200) {
                  this.$message({
                    type: 'warning',
                    message: res.data.msg,
                    duration: 2000,
                    offset: 110
                  })
                }
              } else {
                this.$message({
                  type: 'warning',
                  message: '网络异常',
                  duration: 2000,
                  offset: 110
                })
              }
            })
        }
      },
      resetForm (formName) {
        this.$refs[formName].resetFields()
      },
      save (formName) {
        let _this = this
        this.client.cropList = this.checkCropsDetail
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.type === 0 || this.type === 2 || this.type === 3) {
              this.$axios.request({
                url: process.env.VUE_APP_SERVER + '/psi/client/repetitionClientByClientPhone?clientPhone=' + this.client.clientPhone,
                method: 'GET'
              })
                .then((res) => {
                  if (res.status === 200) {
                    if (res.data.code != 200) {
                      this.$message({
                        type: 'warning',
                        message: res.data.msg,
                        duration: 2000,
                        offset: 110
                      })
                    } else {
                      if (Tool.isNotEmpty(this.client.identityCode)) {
                        if (Pattern.validate('idCode', this.client.identityCode) && this.client.identityCode.indexOf('*') === -1) {
                          this.client.identityCode = BaseDecrypt.encode(this.client.identityCode)
                        } else if (this.client.identityCode.indexOf('*') !== -1) {
                          if(Tool.isNotEmpty(this.client.dataSources)){
                            this.client.identityCode = this.decryptPsd
                          }else{
                            this.client.identityCode = this.secretPsd
                          }

                        } else {
                          if(Tool.isNotEmpty(this.client.dataSources)){
                            this.client.identityCode = this.decryptPsd
                          }else{
                            this.secretPsd = BaseDecrypt.encode(this.client.identityCode)
                            this.decryptPsd = BaseDecrypt.decode(this.secretPsd)
                            this.client.identityCode = this.decryptPsd
                          }

                        }
                      }
                      Loadings.show()
                      this.$axios.post(process.env.VUE_APP_SERVER + '/psi/client/save', this.client)
                        .then((response) => {
                          Loadings.hide()
                          let decrypts=BaseDecrypt.decode(this.client.identityCode)
                          let subID = decrypts.substring(1, decrypts.length-1)
                          let subSecret = []
                          for (let i = 0; i < subID.length; i++) {
                            subSecret.push('*')
                          }
                          this.client.identityCode = decrypts.substr(0, 1) + subSecret.toString().replace(/,/g, '') + decrypts.substr(decrypts.length - 1)
                          if (response.status === 200) {
                            if (response.data.code === 200) {
                              this.$message({
                                type: 'success',
                                message: '新增客户成功！',
                                duration: 2000,
                                offset: 110
                              })
                              setTimeout(() => {
                                if (this.type === 2) {
                                  //跳转到销货开单
                                  this.client = response.data.data
                                  if (Tool.isEmpty(this.client.clientName)) {
                                    this.client.clientName = this.client.clientPerson
                                  }
                                  if(Tool.isNotEmpty(this.client.clientPhone) && Tool.isNotEmpty(this.client.identityCode)
                                    && Tool.isNotEmpty(this.client.addressDesc) && Tool.isNotEmpty(this.client.cropList)){
                                    this.client.idCertified=true
                                  }else{
                                    this.client.idCertified=false
                                  }
                                  let type = 5
                                  this.$router.push({
                                    name: '/saleOrders',
                                    params: {
                                      type,
                                      client: this.client,
                                    }
                                  })
                                  this.openSocket=false
                                } else if (this.type === 3) {
                                  this.client = response.data.data
                                  if (Tool.isEmpty(this.client.clientName)) {
                                    this.client.clientName = this.client.clientPerson
                                  }
                                  let type = 3
                                  this.$router.push({
                                    name: '/recycleOrders',
                                    params: {
                                      type,
                                      item: this.client,
                                    }
                                  })
                                  this.openSocket=false
                                } else {
                                  //跳转到客户列表页面
                                  _this.$router.push('/admin/clientManager')
                                  this.openSocket=false
                                }

                              }, 2000)
                            } else {
                              this.$message({
                                type: 'warning',
                                message: response.data.msg,
                                duration: 2000,
                                offset: 110
                              })
                            }
                          } else {
                            this.$message({
                              type: 'warning',
                              message: '网络异常',
                              duration: 2000,
                              offset: 110
                            })
                          }
                        })
                    }
                  } else {
                    this.$message({
                      type: 'warning',
                      message: '网络异常',
                      duration: 2000,
                      offset: 110
                    })
                  }
                })
            } else if (this.type === 1 || this.type === 4) {
              if (this.client.cropList.length > 0) {
                this.$axios.request({
                  url: process.env.VUE_APP_SERVER + '/psi/client/repetitionClientByClientPhone' +
                    '?clientPhone=' + this.client.clientPhone +
                    '&clientId=' + this.client.clientId,
                  method: 'GET'
                })
                  .then((res) => {
                    if (res.status === 200) {
                      if (res.data.code != 200) {
                        this.$message({
                          type: 'warning',
                          message: res.data.msg,
                          duration: 2000,
                          offset: 110
                        })
                      } else {
                        Loadings.show()
                        if (Tool.isNotEmpty(this.client.identityCode)) {
                          if (Pattern.validate('idCode', this.client.identityCode) && this.client.identityCode.indexOf('*') === -1) {
                            if(Tool.isNotEmpty(this.client.dataSources)){
                              console.log("")
                            }else{
                              this.client.identityCode = BaseDecrypt.encode(this.client.identityCode)
                            }

                          } else if (this.client.identityCode.indexOf('*') !== -1) {
                            if(Tool.isNotEmpty(this.client.dataSources)){
                              this.client.identityCode = this.decryptPsd
                            }else{
                              this.client.identityCode = this.secretPsd
                            }

                          } else {
                            if(Tool.isNotEmpty(this.client.dataSources)){
                              this.client.identityCode = this.decryptPsd
                            }else{
                              this.secretPsd = BaseDecrypt.encode(this.client.identityCode)
                              this.decryptPsd = BaseDecrypt.decode(this.secretPsd)
                              this.client.identityCode = this.decryptPsd
                            }

                          }
                        }
                        this.$axios.request({
                          url: process.env.VUE_APP_SERVER + '/psi/client/update',
                          method: 'POST',
                          data: this.client
                        })
                          .then((response) => {
                            Loadings.hide()
                            let decrypts=BaseDecrypt.decode(this.client.identityCode)
                            let subID = decrypts.substring(1, 17)
                            let subSecret = []
                            for (let i = 0; i < subID.length; i++) {
                              subSecret.push('*')
                            }
                            this.client.identityCode = decrypts.substr(0, 1) + subSecret.toString().replace(/,/g, '') + decrypts.substr(decrypts.length - 1)
                            if (response.status === 200) {
                              if (response.data.code === 200) {
                                this.$message({
                                  type: 'success',
                                  message: '修改客户信息成功！',
                                  duration: 2000,
                                  offset: 110
                                })
                                //跳转到客户列表页面
                                if (this.type === 1) {
                                  this.$router.push('/admin/clientManager')
                                } else if (this.type === 4) {
                                  this.client = response.data.data
                                  if (Tool.isEmpty(this.client.clientName)) {
                                    this.client.clientName = this.client.clientPerson
                                  }
                                  let type = 6
                                  this.$router.push({
                                    name: '/saleOrders',
                                    params: {
                                      type,
                                      client: this.client,
                                    }
                                  })
                                }

                              } else {
                                this.identityCode=''
                                this.$message({
                                  type: 'warning',
                                  message: response.data.msg,
                                  duration: 2000,
                                  offset: 110
                                })
                              }
                            } else {
                              this.$message({
                                type: 'warning',
                                message: '网络异常',
                                duration: 2000,
                                offset: 110
                              })
                            }
                            /*
                            this.clients = resp.data.data.records;
                            this.$refs.pageHelper.render(page, resp.data.totalSize)
                            */
                          })
                      }
                    } else {
                      this.$message({
                        type: 'warning',
                        message: '网络异常',
                        duration: 2000,
                        offset: 110
                      })
                    }
                  })
              } else {
                this.$message({
                  type: 'error',
                  message: '请选择种植作物',
                  duration: 2000,
                  offset: 110
                })
              }

            }
          } else {
            return false
          }
        })
      },
      //2.停用客户
      radioChange (e) {
        if (e === 1) {
          this.showStopInfo = true
        } else {
          this.showStopInfo = false
        }
        //key === this.client.status ? this.client.status = key:this.client.status=0;
      },
      //3.省市区
      handleArea (value) {
        //console.log(value)
      },
      navChange () {
        let flag = 0
        if (this.type === 1) {
          flag = 1
        }
        this.$emit('navChange', flag)
        SessionStorage.set(EDIT_FLAG, flag)
      },
      getIdentityInfo () {
        console.log('身份证识别中...')
        let _this=this
        $.ajax({
          url: 'http://localhost:8989/api/ReadMsg',
          type: 'GET',
          success: function (data) {
            let resp = data;
            _this.client.realName=resp.name;
            _this.client.identityCode=resp.cardno;
            _this.client.addressDesc=resp.address;
          }
        });
      },
      socketIOIdScan(){
        //IE10以下的socket.io仍使用轮询方式和服务器通信，轮询过程中会导致重连，暂时不清楚原因。
        //如果服务端向客户端发送数据时发生重连，大概需要3秒多客户端才能收到数据
        //这里打开io的时候设置重连等待时间尽可能短，以减少接收数据的延时。
        let _this=this
        if(_this.openSocket){
          let socket = io.connect('http://localhost:5000',{'timeout': 30000,'reconnectionDelayMax':1000,'reconnectionDelay':500});

          socket.on('connect', function () {
            socket.emit('startRead');
          });
          socket.on('disconnect', function () {
            /*_this.$message({
              type: 'error',
              message: '设备已断开连接',
              duration: 2000,
              offset: 110
            })*/
          });
          socket.on('card message', function(msg){
            let result1 = Base64.decode(msg);
            let data = eval("("+result1+")");
            _this.client.realName=data.name;
            _this.client.identityCode=data.cardno;
            _this.client.addressDesc=data.address;
          });
        }

      },
    }
  }
</script>

<style scoped>
  /deep/ .el-form-item__label {
    font-size: 15px;
  }

  /deep/ .el-form-item__label:before {
    margin-left: 4px;
    float: right;
  }

  .mainPages {
    height: calc(100vh - 120px);
    overflow-y: scroll;
    overflow-x: hidden;
  }

  /*顶部导航*/
  .pageNav {
    display: inline-block;
    float: left;
    position: relative;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .horizontalLine {
    width: 100%;
    height: 5px;
    border: 5px solid #e9eef3;
    border-radius: 20px;
    margin-top: 60px;
  }

  .returnPrevious {
    float: left;
  }

  .verticalLine {
    position: absolute;
    top: 5px;
    float: left;
    left: 150px;
    width: 5px;
    height: 30px;
    border-radius: 40px;
    background-color: #409EFF;
  }

  .descTitle {
    margin-left: 25px;
    font-size: 16px;
    line-height: 40px;
    text-decoration: none;
  }

  /*表单*/
  .mainForm {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .storeInfoBtn {
    background: #e92322;
    width: 150px;
    margin-left: -150px;
  }

  .resetBtn {
    width: 150px;
  }

  .inputLine {
    max-width: 370px;
    float: left;
  }

  .inputLineArea {
    max-width: 800px;
    float: left;
  }

  .checkArea {
    float: left;
  }

  /*停用启用*/
  .checkGroup {
    float: left;
    border: 1px solid #DCDFE6;
    border-radius: 5px;
    padding-left: 5px;
    padding-top: 5px;
    padding-right: 5px;
  }

  /deep/ .el-radio-button__inner, .el-radio-button:first-child {
    border: 0 !important;
  }

  .showStopInfo {
    text-align: left;
    margin-left: 120px;
    border: 1px solid #DCDFE6;
    border-radius: 5px;
    max-width: 450px;
    padding: 10px;
    margin-top: -10px;
    margin-bottom: 20px;
    color: #9c9c9c;
    background-color: #eeeeee;
    cursor: pointer;
  }

  /*备注*/
  .inputCoreDesc {
    max-width: 500px;
    float: left;
  }

  /deep/ .el-autocomplete-suggestion li {
    line-height: 20px !important;
    padding: 7px;
  }

  .name {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .addr {
    font-size: 12px;
    color: #b4b4b4;
  }

  .highlighted .addr {
    color: #ddd;
  }

  /deep/ .el-textarea .el-input__count {
    background: unset;
    bottom: -10px;
    right: 20px;
  }

  .sfzIconBox {
    width: 100%;
    float: left;
  }

  .mastIcon {
    color: #e92322;
    margin-left: 5px;
  }

  .sfzTitle {
    width: 100px;
    float: left;
    vertical-align: middle;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 5px;
    font-size: 16px;
    font-weight: 700;
    box-sizing: border-box;
    text-align: left;
  }

  .clickBox {
    max-width: 900px;
    height: 60px;
    margin-bottom: 20px;
    margin-left: 20px;
    background: #fcf9ef;
    border-radius: 5px;
    padding: 8px;
    cursor: pointer;
  }

  .sfzIcon {
    width: 100px;
    float: left;
    margin-left: -10px;
    margin-top: -6px;
  }

  .clickMessage {
    color: #999999;
    float: left;
  }

  .clickMessage div:first-of-type {
    font-size: 16px;
  }

  .clickMessage div:last-of-type {
    font-weight: 700;
  }

  /*种植作物*/
  .cropBox {

    margin-bottom: 20px;
  }

  .cropTitle {
    width: 100px;
    float: left;
    vertical-align: middle;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 5px;
    font-size: 15px;
    font-weight: 700;
    box-sizing: border-box;
    text-align: left;
    margin-left: 20px;
  }

  .cropCat {
    max-width: 800px;
    margin-left: 120px;
  }

  /*种植box*/
  /deep/ .el-tabs__nav {
    background: #1684F0;
    z-index: unset;
  }

  /deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: #ffffff;
    padding: 0 10px;
  }

  /deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(2) {
    padding-left: 10px !important;
  }

  /deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #1684F0 !important;
  }

  /deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
    background-color: #F5F7FA;
  }

  /deep/ .el-tabs--border-card {
    border-radius: 6px;
  }

  /deep/ .el-tabs__nav-wrap.is-scrollable {
    padding: 0 30px;
  }

  /deep/ .el-tabs__nav-next, /deep/ .el-tabs__nav-prev {
    color: #1684F0;
    background: #e2e7ec;
    font-size: 30px;
    line-height: 40px;
  }

  /deep/ .el-tabs__nav-next:hover, /deep/ .el-tabs__nav-prev:hover {
    background: unset;
    color: #1684F0;
  }

  /*选中标签*/
  .cropCheckBox {
    margin-top: 15px;
    margin-bottom: 20px;
    max-width: 950px;
  }

  /deep/ .el-tag {
  }

  .cropTag {
    background-color: unset;
    border-color: unset;
    /*height: 30px;*/
    /*max-width: 60px;*/
    /*line-height: 30px;*/
    /*float: left;*/
    padding: 0;
    font-size: 14px;
    color: #606266;
    white-space: nowrap;
    border-width: unset;
    border-style: unset;
    border-radius: unset;
    box-sizing: unset;
    margin-right: 40px;
    margin-bottom: 20px;
  }

  .inputBox {
    /*float: left;*/
    margin-left: 0px;
    height: 20px;
  }

  .inputTitle {
    font-size: 15px;
    display: inline-flex;

  }

  /deep/ .el-input-number.is-controls-right .el-input__inner {
    /*padding-left: 10px;
    padding-right: 10px;
    height: 30px;
    line-height: 30px;*/
  }

  /deep/ .el-input-number {
    width: 140px;
    margin-right: 10px;
  }

  /deep/ .el-tag .el-icon-close {
    right: -120px;
    line-height: 20px;
    font-size: 14px;
    width: 20px;
    height: 20px;
    background: #409eff;
    color: white;
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    top: -18px;
    vertical-align: middle;
  }
</style>
